// import { Arr_AllSEFQuestions } from "../../../../arrays/Arr_AllSEFQuestions";
import CheckConditions from "../CheckConditions";

const getArrayOfQuestionsAndNeededToSubmit = (
  Page,
  formInfo,
  Arr_AllSEFQuestions
) => {
  //Get all questions for this page
  let arrayOfQuestions = Arr_AllSEFQuestions.filter((Obj) => {
    return Obj.Page === Page;
  });
  let Arr_QuestionsNeededToSubmit = arrayOfQuestions.filter((Obj) => {
    return (
      CheckConditions(
        formInfo,
        Obj.onlyAppearIfValueIs,
        Obj.onlyAppearIfValueIsNot,
        Obj.withRegardsTo
      ) === true
    );
  });
  Arr_QuestionsNeededToSubmit = Arr_QuestionsNeededToSubmit.filter((Obj) => {
    return Obj.SpecialCondition !== "Optional";
  });
  let neededToSubmit = Arr_QuestionsNeededToSubmit.filter((Obj) => {
    return (
      !formInfo[Obj.name] ||
      formInfo[Obj.name] == "" ||
      formInfo[Obj.name] == null ||
      formInfo[Obj.name] == undefined
    );
  });

  return {
    arrayOfQuestions: arrayOfQuestions,
    neededToSubmit: neededToSubmit,
  };
  // return { ["yeet"], ["beet"], };
};

export default getArrayOfQuestionsAndNeededToSubmit;

// Use the function to get the arrays
//   const { arrayOfQuestions, neededToSubmit } = getArrayOfQuestionsAndNeededToSubmit("aa", "bb");
